import {
  Labels,
  ModulesWithLabels,
  ReferenceTargets,
} from '../../store/types'
import { ModulesAction } from '../../store/actions/modules'
import {
  ADD_LABEL_TO_MODULE,
  CREATE_LABEL,
  REMOVE_LABEL,
  REMOVE_LABEL_FROM_MODULE,
  SET_LABELS,
  SET_MODULES_WITH_LABELS,
  SET_REFERENCE_TARGETS,
  UPDATE_LABEL,
} from '../../store/constants'
import { createIdFromName, sortRefTargets } from "../../helpers"

export interface ModulesReduxState {
  labels: Labels
  modulesWithLabels: ModulesWithLabels
  referenceTargets: ReferenceTargets
}

export const initialState: ModulesReduxState = {
  labels: {},
  modulesWithLabels: {},
  referenceTargets: new Map(),
}

// eslint-disable-next-line default-param-last
export function reducer(state: ModulesReduxState = initialState, action: ModulesAction) {
  switch (action.type) {
  case SET_REFERENCE_TARGETS: {
    const targets = new Map(state.referenceTargets)
    targets.set(action.data.moduleId, action.data.targets.sort(sortRefTargets))
    return {
      ...state,
      referenceTargets: targets,
    }
  }

  case CREATE_LABEL: {
    const label = action.data
    const labels = { ...state.labels }
    const id = createIdFromName(label.name)
    labels[id] = { id, ...label }
    localStorage.setItem('labels', JSON.stringify(labels))
    return {
      ...state,
      labels,
    }
  }

  case REMOVE_LABEL: {
    const id = typeof action.data === 'string' ? action.data : action.data.id
    const labels = { ...state.labels }
    const modulesWithLabels = { ...state.modulesWithLabels }
    delete labels[id]
    for (const [modId, labels] of Object.entries(modulesWithLabels)) {
      const index = labels.indexOf(id)
      if (index >= 0) {
        modulesWithLabels[modId] = labels.filter(l => l !== id)
      }
      if (modulesWithLabels[modId].length === 0) {
        delete modulesWithLabels[modId]
      }
    }
    localStorage.setItem('labels', JSON.stringify(labels))
    localStorage.setItem('modulesWithLabels', JSON.stringify(modulesWithLabels))
    return {
      ...state,
      labels,
      modulesWithLabels,
    }
  }

  case SET_LABELS:
    localStorage.setItem('labels', JSON.stringify(action.data))
    return {
      ...state,
      labels: action.data,
    }

  case UPDATE_LABEL: {
    const { id, data } = action.data
    const labels = { ...state.labels }
    labels[id] = { ...labels[id], ...data }
    localStorage.setItem('labels', JSON.stringify(labels))
    return {
      ...state,
      labels,
    }
  }

  case SET_MODULES_WITH_LABELS:
    localStorage.setItem('modulesWithLabels', JSON.stringify(action.data))
    return {
      ...state,
      modulesWithLabels: action.data,
    }

  case ADD_LABEL_TO_MODULE: {
    const { module, label } = action.data
    const id = typeof label === 'string' ? label : label.id
    const modulesWithLabels = { ...state.modulesWithLabels }
    if (modulesWithLabels[module]) {
      const labels = modulesWithLabels[module]
      if (labels.indexOf(id) >= 0) return state
      modulesWithLabels[module] = labels.concat(id)
    } else {
      modulesWithLabels[module] = [id]
    }
    localStorage.setItem('modulesWithLabels', JSON.stringify(modulesWithLabels))
    return {
      ...state,
      modulesWithLabels,
    }
  }

  case REMOVE_LABEL_FROM_MODULE: {
    const { module, label } = action.data
    const id = typeof label === 'string' ? label : label.id
    const modulesWithLabels = { ...state.modulesWithLabels }
    modulesWithLabels[module] = modulesWithLabels[module].filter(lId => lId !== id)
    const labels = modulesWithLabels[module]
    if (labels.length === 0) {
      delete modulesWithLabels[module]
    }
    localStorage.setItem('modulesWithLabels', JSON.stringify(modulesWithLabels))
    return {
      ...state,
      modulesWithLabels,
    }
  }

  default:
    return state
  }
}
